import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function LocationIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 12C16 14.2078 14.2078 16 12 16C9.79222 16 8 14.2078 8 12C8 9.79391 9.78976 8 11.9992 8C14.2053 8 16 9.79054 16 12ZM12 14C13.1032 14 14 13.1032 14 12C14 10.8965 13.1021 10 11.9992 10C10.8957 10 10 10.8971 10 12C10 13.1032 10.8968 14 12 14Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 12C16 14.2078 14.2078 16 12 16C9.79222 16 8 14.2078 8 12C8 9.79391 9.78976 8 11.9992 8C14.2053 8 16 9.79054 16 12ZM12 14C13.1032 14 14 13.1032 14 12C14 10.8965 13.1021 10 11.9992 10C10.8957 10 10 10.8971 10 12C10 13.1032 10.8968 14 12 14Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 12C14 13.1032 13.1032 14 12 14C10.8968 14 10 13.1032 10 12C10 10.8971 10.8957 10 11.9992 10C13.1021 10 14 10.8965 14 12ZM12 16C14.2078 16 16 14.2078 16 12C16 9.79054 14.2053 8 11.9992 8C9.78976 8 8 9.79391 8 12C8 14.2078 9.79222 16 12 16Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 2H13V3.05552C17.1647 3.51916 20.4823 6.83348 20.9448 11H22V13H20.9449C20.4827 17.1668 17.1668 20.4827 13 20.9449V22H11V20.9449C6.83319 20.4827 3.51734 17.1668 3.05513 13H2V11H3.05509C3.51701 6.8329 6.83107 3.51552 11 3.05474V2ZM19 12C19 15.8599 15.8599 19 12 19C8.14014 19 5 15.8599 5 12C5 8.14014 8.13662 5 11.9965 5C15.8563 5 19 8.14014 19 12Z",
    fill: "currentColor"
  }));
}